import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";

export default function CustomerTable() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");

  // --- Filter States ---
  const [searchName, setSearchName] = useState("");
  const [searchDivision, setSearchDivision] = useState("");

  useEffect(() => {
    fetchFailedCollectFee();
  }, []);

  const fetchFailedCollectFee = async () => {
    setIsLoading(true);
    try {
      const payload = {
        customer_id: 1005,
        api_key: "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        division_id: "270",
        student_name: "",
      };

      const response = await simplePostCall(
        ApiConfig.customersList,
        JSON.stringify(payload)
      );

      if (response?.result) {
        const formattedData = response.academicYear.map((item, index) => ({
          id: index + 1,
          name: item.student_name || "",
          grade: item.class_name || "",
          division: item.class_division_name || "",
          invoiceno: item.student_id
        }));

        setData(formattedData);
        setMessage("Data retrieved successfully");
      } else {
        setMessage(response?.message || "No results found");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      setMessage("Error fetching details");
    } finally {
      setIsLoading(false);
    }
  };

  // --- Filtering Logic ---
  const filteredData = data.filter((item) => {
    return (
      item.name.toLowerCase().includes(searchName.toLowerCase()) &&
      item.division.toLowerCase().includes(searchDivision.toLowerCase())
    );
  });

  const handleClear = () => {
    setSearchName("");
    setSearchDivision("");
  };

  return (
    <div className="customer-container my-4">
      <div className="special-header panel-white-all">
        <h4 className="page-title mt-1">Customer</h4>
      </div>

      <div className="table-top-filters d-flex flex-wrap gap-3 mb-3">
        {/* STUDENT NAME FILTER */}
        <div style={{ position: "relative", maxWidth: "200px" }}>
          <FaSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              fontSize: "13px",
              color: "#999",
            }}
          />
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Student Name"
            style={{ paddingLeft: "30px" }}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
        </div>

        {/* STUDENT DIVISION FILTER */}
        <div style={{ position: "relative", maxWidth: "200px" }}>
          <FaSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              fontSize: "13px",
              color: "#999",
            }}
          />
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Student Division"
            style={{ paddingLeft: "30px" }}
            value={searchDivision}
            onChange={(e) => setSearchDivision(e.target.value)}
          />
        </div>

        <button
          type="button"
          className="btn btn-secondary btn-sm"
          style={{ height: "31px" }}
          onClick={handleClear}
        >
          Clear
        </button>
      </div>

      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="custom-table w-100">
              <thead>
                <tr>
                  <th className="text-center">Sr No</th>
                  <th className="text-center">Student Name</th>
                  <th className="text-center">Grade</th>
                  <th className="text-center">Division</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center p-3">Loading...</td>
                  </tr>
                ) : filteredData.length > 0 ? (
                  filteredData.map((row) => (
                    <tr key={row.id}>
                      <td className="text-center" style={{ fontSize: "13px", height: "50px" }}>{row.id}</td>
                      <td className="text-center" style={{ fontSize: "13px", height: "50px" }}>{row.name}</td>
                      <td className="text-center" style={{ fontSize: "13px", height: "50px" }}>{row.grade}</td>
                      <td className="text-center" style={{ fontSize: "13px", height: "50px" }}>{row.division}</td>
                      <td className="text-center" style={{ height: "50px" }}>
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => navigate(`/ViewInvoiceCustomer/${row.invoiceno}`)}
                          title="View"
                        >
                          <i className="bi bi-eye"></i> View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center p-3">
                      {message || "No Data Found matching your search"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}